module.exports = require("@pb/kit-util-get-view-port-size");